export const LOCAL_STORAGE_CAR = 'driverup-selected-car';
export const LOCAL_STORAGE_DEALER_APP_KEY = 'driverup-dealer-app-key';
export const LOCAL_STORAGE_DEALER_APP_VALUE = 'driverup-dealer-app-value';
export const DU_ACCESS_TOKEN = 'du_ac';
